export default (name) => {
  try {
    return JSON.parse(localStorage.getItem(name)) || {};
  } catch (e) {
    return {};
  }
};
